import React from 'react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/Button/Button'

export const Plans = ({
  data,
  onSelectPlan,
  onClick,
}: {
  data: any
  onSelectPlan: (i: number) => void
  onClick: () => void
}) => {
  return (
    <>
      <div>
        {data.items.map((el: any, i: number) => {
          const active = i === data.active
          return (
            <div
              key={el.name + i}
              className={cn(
                {
                  'before:opacity-100 bg-[#34976014]': active,
                  'before:opacity-0 bg-boxBg': !active,
                },
                'rounded-3xl mt-3 relative before:absolute before:top-0 before:left-0 before:w-full before:h-full before:z-10 before:pointer-events-none before:border-2 before:border-buttonGradient before:rounded-3xl before:transition-all ',
              )}
            >
              <button
                onClick={() => onSelectPlan(i)}
                className={cn(' py-[18px] px-5 w-full flex items-center justify-between gap-2')}
              >
                <div className="flex items-center gap-4">
                  <div
                    className={cn(
                      { 'border-buttonGradient': active, 'border-[#101A363D]': !active },
                      'min-w-[22px] w-[22px] h-[22px] rounded-full border-2 flex transition-all items-center justify-center',
                    )}
                  >
                    <span
                      className={cn(
                        { 'opacity-100': active, 'opacity-0': !active },
                        ' block w-[14px] h-[14px] rounded-full bg-buttonGradient transition-all',
                      )}
                    ></span>
                  </div>
                  <p className="font-semibold text-left">{el.name}</p>
                </div>
                {el.tag && (
                  <p
                    className={cn(
                      { 'bg-buttonGradient text-black': active, 'bg-[#101A360A]': !active },
                      ' py-[5px] px-[10px] rounded-full text-[10px] font-bold uppercase transition-all',
                    )}
                  >
                    {el.tag}
                  </p>
                )}

                <p className="flex flex-col grow text-end">
                  <span className="font-semibold">${el.perDayDiscount}</span>
                  <span className="font-medium text-[12px] text-[#101A3666] line-through">
                    ${el.perDay}
                  </span>
                </p>
              </button>
            </div>
          )
        })}
      </div>

      <p className="flex items-center justify-center gap-[6px] text-buttonGradient font-semibold text-[14px] mt-[30px]">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2749_3632)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.86035 0.0193557C7.95136 -0.00689943 8.04874 -0.00689952 8.13965 0.0193557L14.6533 1.90217C14.8589 1.96166 14.9999 2.14453 15 2.35139V9.25471C15 10.1527 14.622 11.0722 13.8779 11.9871C13.3097 12.6858 12.5241 13.388 11.542 14.0731C9.89216 15.2238 8.26701 15.9292 8.19824 15.9588C8.13508 15.986 8.06765 15.9998 8 15.9998C7.93232 15.9998 7.86492 15.986 7.80176 15.9588C7.73327 15.9293 6.10798 15.2239 4.45801 14.0731C3.47588 13.388 2.69033 12.6858 2.12207 11.9871C1.37805 11.0722 1 10.1527 1 9.25471V2.35139C1.00011 2.14452 1.14104 1.96165 1.34668 1.90217L7.86035 0.0193557ZM11.207 5.79279C10.8165 5.40233 10.1835 5.40234 9.79297 5.79279L7.5 8.08576L6.70703 7.29279C6.31652 6.90233 5.68348 6.90234 5.29297 7.29279C4.90246 7.6833 4.90249 8.31633 5.29297 8.70686L7.5 10.9139L11.207 7.20686C11.5975 6.81633 11.5975 6.1833 11.207 5.79279Z"
              fill="#349760"
            />
          </g>
          <defs>
            <clipPath id="clip0_2749_3632">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        30-day money-back guarantee
      </p>

      <Button onClick={onClick} className="mt-8 pulsating-button" variant="multistep">
        Get my plan
      </Button>

      <p
        className="text-center mt-8 text-[#101A36B2] text-[14px] font-medium [&_a]:text-buttonGradient [&_a]:hover:underline"
        dangerouslySetInnerHTML={{ __html: data.items[data.active].text }}
      ></p>
    </>
  )
}
